import { makeStyles, createStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { desktopMinWidth } from 'utils/windowHelpers';

type PictureZoomProps = {
  url?: string;
  width?: number;
  alt?: string;
  height?: number;
};

const PictureZoom = ({ url, width, alt, height }: PictureZoomProps) => {
  const [isFullscreenViewOpen, setIsFullscreenViewOpen] = useState(false);

  const useStyles = makeStyles(() =>
    createStyles({
      root: {},
      container: {
        width: 'fit-content',
        backgroundColor: 'transparent',
        padding: 10,
        border: '1px solid #AAAAAA',
        borderRadius: 4,
        cursor: 'zoom-in',
        [desktopMinWidth]: {
          padding: 20,
        },
      },
      image: {
        width,
        height,
        display: 'block',
      },
      fullscreenView: {
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        display: isFullscreenViewOpen ? 'flex' : 'none',
        zIndex: 999,
        background: 'rgba(0, 0, 0, 0.5)',
        cursor: 'zoom-out',
      },
      fullscreenImage: {
        display: 'block',
        width: '90%',
        margin: 'auto',
        [desktopMinWidth]: {
          width: 'auto',
          margin: '0 auto',
        },
      },
    }),
  );
  const classes = useStyles();

  const showFullscreenView = () => setIsFullscreenViewOpen(true);
  const hideFullscreenView = () => setIsFullscreenViewOpen(false);

  return (
    <>
      <div className={classes.container} onClick={showFullscreenView}>
        <img src={url} className={classes.image} alt={alt} />
      </div>
      <div className={classes.fullscreenView} onClick={hideFullscreenView}>
        <img src={url} alt={alt} className={classes.fullscreenImage} />
      </div>
    </>
  );
};

export default PictureZoom;
